import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { array, number, object, string } from 'yup'

import messages from './messages'

export const appCatalogFormSchema = (config: any, state: any) => {
  const schema: Record<string, any> = {
    pollingInterval: number(),
    ...Object.keys(config.properties || []).reduce((final, objKey) => {
      const requiredFields = get(config, 'required', [])
      const isEmail =
        get(config.properties[objKey], 'format', '').toLowerCase() === 'email' ||
        get(config.properties[objKey], 'title', '').toLowerCase().includes('email')
      const isURL =
        get(config.properties[objKey], 'format', '').includes('uri') ||
        get(config.properties[objKey], 'format', '').includes('url')
      if (isEmail && requiredFields.includes(objKey)) {
        // @ts-expect-error
        final[objKey] = string()
          .trim()
          // @ts-expect-error
          .email(<FormattedMessage {...messages.invalidEmail} />)
          // @ts-expect-error
          .required(<FormattedMessage {...messages.requiredError} />)
      } else if (isURL) {
        // @ts-expect-error
        final[objKey] = string()
          .trim()
          // @ts-expect-error
          .url(<FormattedMessage {...messages.invalidURL} />)
          // @ts-expect-error
          .required(<FormattedMessage {...messages.requiredError} />)
      } else if (isEmail) {
        // @ts-expect-error
        final[objKey] = string()
          .trim()
          // @ts-expect-error
          .email(<FormattedMessage {...messages.invalidEmail} />)
      } else if (requiredFields.includes(objKey)) {
        // @ts-expect-error
        final[objKey] = string().required(<FormattedMessage {...messages.requiredError} />)
      } else {
        // @ts-expect-error
        final[objKey] = string().trim()
      }
      return final
    }, {}),
    audienceTargeting: array().of(
      object().shape({
        filters: array().of(
          object().shape({
            attribute: object().required().label('Attribute'),
            operator: string().required().label('Operator'),
            value: string().required().label('Value')
          })
        )
      })
    )
  }

  const { appImageOverride, appNameOverride, audienceTargeting, pollingInterval, ...rest } = schema
  return object().shape({
    appImageOverride,
    appNameOverride,
    ...(state.isAudienceTargetingExpanded && { audienceTargeting }),
    ...(state.isSmartNotificationsExpanded && { pollingInterval }),
    ...rest
  })
}
